import "./BoxesModule.css"
import Module from "../../Model/Module";
import BoxModule from "../BoxModule/BoxModule";

interface BoxesModuleProps {
    boxes: Module[]
    setPageOnClick: (page: string) => void;
}

export default function BoxesModule (props : BoxesModuleProps) {
    return (
        <div className="grid">
            {props.boxes.map((box, index) => {
                return <BoxModule key={index} box={box} setPageOnClick={props.setPageOnClick}></BoxModule>
            })}
        </div>
    )
}